import { createPortal } from 'react-dom'
import { ContainerOverlay, Container, ScrollContent } from './styles'
import { useEffect } from 'react'

interface ModalProps {
    id: string
    children: any
    onClose: () => void
    openModal: boolean
    width?: string
    height?: string
    maxWidth?: string
    maxHeight?: string
    noScroll?: boolean
    contentPadding?: string
    handleOnFinish?(): void
}

export default function ModalDefault({ id, onClose, width, height, openModal, children, maxWidth, maxHeight, noScroll = false, contentPadding, handleOnFinish = () => { } }: ModalProps) {
    useEffect(() => {
        if (openModal) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
        
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [openModal])

    const modalContent = (
        <ContainerOverlay id={id} openModal={openModal}>
            <Container
                width={width}
                height={height}
                openModal={openModal}
                maxWidth={maxWidth}
                maxHeight={maxHeight}
                noScroll={noScroll}
                contentPadding={contentPadding}
            >
                {noScroll ? children : <ScrollContent>{children}</ScrollContent>}
            </Container>
        </ContainerOverlay>
    )

    return typeof document !== 'undefined' && document.body
        ? createPortal(modalContent, document.body)
        : modalContent
}